import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

export const clearAuthenticationState = () => {
  window.localStorage.removeItem("id_token");
  window.localStorage.removeItem("ExpiresAt");
  window.localStorage.removeItem("AccessToken");
  window.localStorage.removeItem("RefreshToken");
  window.localStorage.removeItem("Authenticated");
  window.localStorage.removeItem("Username");

  if (Vue.axios && Vue.axios.defaults.headers.common) {
    delete Vue.axios.defaults.headers.common.Authorization;
  }
};

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
   //Vue.axios.defaults.baseURL = "https://dmsdemo.vibhaait.in/api/api";
     Vue.axios.defaults.baseURL = "https://contribute.swagathamsai.com/backend/api";

    Vue.axios.interceptors.response.use(
      response => response,
      error => {
        const config = error.config || {};
        const headers = config.headers || {};
        const authorization = headers.Authorization || headers.authorization;
        const isLoginRequest = (config.url || "").indexOf("/auth/login") !== -1;

        if (
          error.response &&
          error.response.status === 401 &&
          authorization &&
          localStorage.getItem("AccessToken") &&
          !isLoginRequest
        ) {
          clearAuthenticationState();
          window.location.href = "/login";
        }

        return Promise.reject(error);
      }
    );
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common["Authorization"] =
      `Bearer ` + localStorage.getItem("AccessToken");
    Vue.axios.defaults.headers.common["Content-Type"] = `application/json`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  getPDF(resource, slug = "") {
    const endpoint = slug ? `${resource}/${slug}` : resource;
    return Vue.axios
      .get(endpoint, { responseType: "arraybuffer" })
      .catch(error => {
        // console.log(error);
        throw new Error(`[KT] ApiService ${error}`);
      });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.post(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
